export const AVAILABLE_DISCS = [
  { id: '1', genre: 'Sci-Fi', color: '#3b82f6' },
  { id: '2', genre: 'Noir', color: '#525252' },
  { id: '3', genre: 'Western', color: '#92400e' },
  { id: '4', genre: 'Horror', color: '#991b1b' },
  { id: '5', genre: 'Rom-Com', color: '#db2777' },
  { id: '6', genre: 'Kung Fu', color: '#ca8a04' },
];

